export default __webpack_public_path__ + "static/media/childDevelopmnet-blob5.e83d5c9d.svg";